import { ITag } from "@/Case/models/ITag";
import { ActionContext } from "vuex";
import { LoggerService as lgg } from "vue-components-library";
import CaseService from "@/Case/services/Case.Service";

const LOG_TAG = "[CASE STORE]";

const createUpdateTagsSelectionStateEvent = (event: any, tag: ITag, shouldSetSelected: boolean, fields?: any): any => {
  return { ...event, data: { tag, selected: shouldSetSelected, fields: fields } };
};

export const updateTagsSelectionState = async (
  context: ActionContext<any, any>,
  event: any,
  tag: ITag,
  shouldSetSelected: boolean,
  fields?: Array<Object>,
) => {
  const lggData = { case: { id: context.getters.caseId }, tag };

  try {
    const updateTagEvent = createUpdateTagsSelectionStateEvent(event, tag, shouldSetSelected, fields);
    context.commit("MODIFY_CASE", updateTagEvent);

    if (shouldSetSelected) {
      if (fields) {
        await CaseService.addDataEnabledTag(context.getters.caseId, tag.id, fields);
      } else {
        await CaseService.addTag(context.getters.caseId, tag.id);
      }
    } else {
      await CaseService.deleteTag(context.getters.caseId, tag.id);
    }
  } catch (error) {
    lgg.error(`${LOG_TAG} Failed to update Tags selection`, {
      error,
      ...lggData,
    });
    throw error;
  }
};

export const addExclusiveTag = async (
  context: ActionContext<any, any>,
  event: any,
  tagToAdd: ITag,
  tagToDelete: ITag,
) => {
  const lggData = {
    case: { id: context.getters.caseId },
    tagToAdd,
    tagToDelete,
  };
  try {
    const addTagEvent = createUpdateTagsSelectionStateEvent(event, tagToAdd, true);
    context.commit("MODIFY_CASE", addTagEvent);

    const deleteTagEvent = createUpdateTagsSelectionStateEvent(event, tagToDelete, false);
    context.commit("MODIFY_CASE", deleteTagEvent);

    await CaseService.deleteTag(context.getters.caseId, tagToDelete.id);
    await CaseService.addTag(context.getters.caseId, tagToAdd.id);
  } catch (error) {
    lgg.error(`${LOG_TAG} Failed to add exclusive Tag`, { error, ...lggData });
    throw error;
  }
};
